import { $, $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { viewport } from './getViewport';

gsap.registerPlugin(DrawSVGPlugin);

export const fadingElements = (elements, timeline) => {
  const duration = 5;

  elements.forEach((element, index) => {
    if (index === 0) {
      timeline
        .to(element, {
          opacity: 0,
          duration: duration,
        })
        .addLabel(`fade--${index}`);
    } else if (index > 0 && index !== elements.length - 1) {
      timeline
        .to(element, {
          opacity: 1,
          duration: duration,
        })
        .addLabel(`fade--${index}`);
      timeline.to(element, {
        opacity: 0,
        duration: duration,
      });
    } else if (index === elements.length - 1) {
      timeline
        .to(element, {
          opacity: 1,
          duration: duration,
        })
        .addLabel(`fade--${index}`);
    }
  });
};

export const fadeInFromBottom = (
  elements,
  yPos = viewport.isReduced
    ? 0
    : viewport.isDesktop
    ? 200
    : viewport.isTablet
    ? 140
    : viewport.isMobile
    ? 80
    : 0
) => {
  elements.forEach(el => {
    gsap.set(el, { y: yPos });
    const timeline = gsap.timeline();

    timeline.to(el, {
      y: 0,
      duration: 10,
    });

    ScrollTrigger.create({
      animation: timeline,
      trigger: el,
      start: () => 'top bottom',
      end: () => 'top center',
      toggleActions: 'play pause resume reset',
      scrub: 1,
    });
  });
};

export const animateJumpmark = (jumpmark, section) => {
  const progressValue = section.getAttribute('data-progress');
  const svgPath = jumpmark.querySelector('#statusPath');

  const svgTimeline = gsap.timeline();

  svgTimeline
    .set(svgPath, { strokeWidth: 3 })
    .from(svgPath, { drawSVG: `${progressValue}%` })
    .to(svgPath, { drawSVG: `${progressValue}%` }, { drawSVG: '100%' });
};

export const progress = self => {
  const trigger = self.trigger;
  trigger.setAttribute('data-progress', Math.floor(self.progress * 100));
  const sectionId = trigger.getAttribute('data-id');

  const story = $('.story');
  const jumpmarks = $$('.story-jumpmarks__item', story);

  // get section and connect with jumpmark
  jumpmarks.forEach(jumpmark => {
    const jumpmarkId = jumpmark.getAttribute('data-id');
    if (jumpmarkId === sectionId) {
      animateJumpmark(jumpmark, self.trigger);
    }
  });
};
